/* eslint-disable max-len */
/* eslint-disable max-lines */
import {
    Experiment, PortfolioFacets, ServiceExclusivity, StateShortName,
} from '@acp/shared';
import { FacetOption } from '@acp/core-ui';

export const managedByOptions = [
    {
        label: 'Detector Inspector',
        value: 'DETECTOR_INSPECTOR',
    },
    {
        label: 'Other',
        value: 'OTHER',
    },
];

export const facetCategories: FacetOption[] = [
    {
        label: 'Compliance',
        description: '',
        value: 'COMPLIANCE',
    },
    {
        label: 'Enrolment',
        description: 'Filter properties by enrolment type',
        value: 'ENROLMENT',
        shouldShow: ({ complianceAgencyState }) => {
            if (complianceAgencyState === StateShortName.VIC) {
                return true;
            }

            return false;
        },
    },
    {
        label: 'Properties with invoices due',
        description: '',
        value: 'INVOICES',
    },
    {
        label: 'Properties with quotes pending',
        description: '',
        value: 'QUOTES',
    },
    {
        label: 'Properties with jobs pending',
        description: 'Insights into your bookings',
        value: 'BOOKINGS',
    },
];

export const facetOptions: FacetOption[] = [
    {
        label: 'My subscribed properties',
        description: '',
        value: PortfolioFacets.SubscribedProperties,
        isPinned: true,
        shouldShow: ({ userExperiments }) => userExperiments?.includes(
            Experiment.AgencyCompliancePortalNotifications
        ) === true,
    },
    {
        label: 'Compliant',
        description: '',
        value: PortfolioFacets.CompliantStatus,
        category: 'COMPLIANCE',
    },
    {
        label: 'Pending items',
        description: '',
        value: PortfolioFacets.PendingItemsStatus,
        category: 'COMPLIANCE',
    },
    {
        label: 'Compliance issues',
        description: '',
        value: PortfolioFacets.ComplianceIssuesStatus,
        category: 'COMPLIANCE',
    },
    {
        label: 'Booking in progress',
        description: '',
        value: PortfolioFacets.BookingInProgressStatus,
        category: 'COMPLIANCE',
    },
    {
        label: 'Safer Home plan',
        description: '',
        value: PortfolioFacets.SaferHomePlan,
        category: 'ENROLMENT',
        shouldShow: ({ complianceAgencyState }) => {
            if (complianceAgencyState === StateShortName.VIC) {
                return true;
            }

            return false;
        },
    },
    {
        label: 'PAYG',
        description: '',
        value: PortfolioFacets.PAYG,
        category: 'ENROLMENT',
        shouldShow: ({ complianceAgencyState }) => {
            if (complianceAgencyState === StateShortName.VIC) {
                return true;
            }

            return false;
        },
    },
    {
        label: 'Outstanding',
        description: '',
        value: PortfolioFacets.OutstandingInvoices,
        category: 'INVOICES',
    },
    {
        label: 'Overdue',
        description: 'Requires immediate payment',
        value: PortfolioFacets.OverdueInvoices,
        category: 'INVOICES',
    },
    {
        label: 'With urgent items',
        description: 'Quotes that impact your compliance',
        value: PortfolioFacets.UrgentQuotes,
        category: 'QUOTES',
    },
    {
        label: 'With no urgent items',
        description: '',
        value: PortfolioFacets.NonUrgentQuotes,
        category: 'QUOTES',
    },
    {
        label: 'Booking in progress',
        description: '',
        value: PortfolioFacets.BookingInProgress,
        category: 'BOOKINGS',
    },
    {
        label: 'Rescheduling in progress',
        description: '',
        value: PortfolioFacets.ReschedulingBooking,
        category: 'BOOKINGS',
    },
    {
        label: 'Booked',
        description: '',
        value: PortfolioFacets.ConfirmedBooking,
        category: 'BOOKINGS',
    },
    {
        label: 'Priority booking',
        description: '',
        value: PortfolioFacets.PriorityBooking,
    },
    {
        label: 'Currently vacant',
        description: '',
        value: PortfolioFacets.Vacant,
    },
    {
        label: 'Service overdue',
        description: '',
        value: PortfolioFacets.Overdue,
    },
    {
        label: 'On hold',
        description: 'Enrolments are on hold',
        value: PortfolioFacets.OnHold,
    },
    {
        label: 'Has access issues',
        description: '',
        value: PortfolioFacets.ActiveNotices,
        shouldShow: ({ userExperiments }) => {
            if (userExperiments?.includes(Experiment.AgencyEntryMethod) === true) {
                return false;
            }

            return true;
        },
    },
    {
        label: 'Has access issues',
        description: '',
        value: PortfolioFacets.AccessIssues,
        shouldShow: ({ userExperiments }) => {
            if (userExperiments?.includes(Experiment.AgencyEntryMethod) === true) {
                return true;
            }

            return false;
        },
    },
    {
        label: 'Not integrated',
        description: '',
        value: PortfolioFacets.NotIntegrated,
    },
    {
        label: 'Include cancelled properties',
        description: '',
        value: PortfolioFacets.CancelledProperties,
        shouldShow: () => false,
    },
];

export type PortfolioFilters = {
    services: string[];
    serviceExclusivity: ServiceExclusivity | null;
    facets: string[];
    query: string | null;
    propertyManager: string | null;
    newAccessIssues: boolean;
};
